import Cookies from 'js-cookie';
import React, { useState } from 'react';

const useToken = () => {
  const getToken = () => {
    const tokenString = Cookies.get('token');
    return tokenString;
  };

  const [token, setToken] = useState(getToken());
  const saveToken = (userToken: string) => {
    Cookies.set('token',(userToken));
    setToken(token);
  };
  return {
    setToken: saveToken,
    token,
  };
};

export default useToken;
